<template>
  <div
v-if="isVisible"
    class="fixed inset-0 z-[100] flex items-center justify-center laptop:justify-end laptop:pr-[16px] bg-black bg-opacity-50 font-roboto w-full"
>
    <div
      class="fxModal bg-white rounded-[20px] shadow-2xl mobile:!w-[calc(100%-32px)] tablet:!w-[75%] fxModalPanel flex flex-col overflow-hidden animate-in fade-in zoom-in duration-200"
>
<!-- Header (Figma P8: body-Bg band, title, red X) -->
      <FxModalHeader title="Available Financing Plans" :dismiss="false" class="m-[15px] mb-0" @close="close" />

      <!-- Content -->
      <div class="flex-1 overflow-y-auto mr-[15px]">
        <div class="p-0 m-[15px] mr-[5px]">
          <!-- onlu for desktop -->
          <div
v-for="(section, sIdx) in financialPlans" :key="sIdx"
            class="rounded-lg overflow-hidden mobile:hidden laptop:block" :class="sIdx > 0 ? 'mt-[15px]' : ''"
>
<!-- Category Header (Category 4 & 5 have an extra top bar) -->
            <div
v-if="section.extraHeaders.length > 0"
              class="bg-[#EEF2FF] text-[#333] text-center py-2.5 text-sm font-bold rounded-t-[5px] border-b relative -bottom-2.5"
>
              {{ section.category }}
            </div>

            <table class="w-full text-left text-xs border-separate border-spacing-y-1.5 ">
              <thead>
                <tr>
                  <th class="px-2 text-[12px] font-medium py-[10px] w-[10%] largeDesktop:w-[7%] bg-[#A3AAD2] text-white rounded-l-[5px]" :class="section.extraHeaders.length > 0 ? ' !rounded-t-[0px]' : ''">
Plan No.
</th>
                  <th v-if="section.extraHeaders.length <= 0" class="px-2 text-[12px] font-medium py-[10px] w-[45%] bg-[#A3AAD2] text-white description--text" v-html="section.category" />
                  <th
v-for="h in section.extraHeaders" :key="h"
                    class="px-2 text-[12px] font-medium py-[10px] text-left font-bold bg-[#A3AAD2] text-white w-[15%]"
>
                    {{ h }}
                  </th>
                  <th class="px-2 text-[12px] font-medium py-[10px] text-center font-bold min-w-[20%] border-l border-solid !bg-[#A3AAD2] !text-white" :class="section.extraHeaders.length > 0 ? 'border-[#B9BFDE]' : 'border-[#B9BFDE]'">
Min Loan Amt
</th>
                  <th class="px-2 text-[12px] font-medium py-[10px] text-center font-bold min-w-[20%] border-l border-solid !bg-[#A3AAD2] !text-white" :class="section.extraHeaders.length > 0 ? 'border-[#B9BFDE]' : 'border-[#B9BFDE]'">
Max Loan Amt
</th>
                  <th class="px-2 text-[12px] font-medium py-[10px] w-[5%] text-white !bg-[#A3AAD2] rounded-r-[5px]" :class="section.extraHeaders.length > 0 ? '!rounded-t-[0px]' : ''" />
                </tr>
              </thead>
              <tbody class="table-row-group space-y-2">
                <tr
v-for="(plan, pIdx) in section.plans" :key="pIdx"
                  class="border-b last:border-0 hover:bg-gray-50 cursor-pointer" @click="selectedPlanId = plan"
>
                  <td
class="p-2 text-[13px] w-[10%] largeDesktop:w-[7%] font-medium rounded-l-[5px] text-gray-600 border-solid border-t border-b border-l border-r-0 "
                  :class="selectedPlanId?.id == plan.id ? 'border-[#7695FF]' : 'border-[#EFEFEF]'"
>
{{ plan.plan_number || 'N/A' }}
</td>
                  <td
v-if="plan.description && section.extraHeaders.length == 0" class="p-2 text-[13px] w-[45%] text-gray-700 border-y border-solid" :class="selectedPlanId?.id == plan.id ? 'border-[#7695FF]' : 'border-[#EFEFEF]'"
                  v-html="plan.description"
/>

                  <!-- Dynamic columns for Interest Rate, Payment Factor -->
                  
                  <td
v-if="section.extraHeaders && section.extraHeaders.includes('Interest Rate')" class="p-2 text-[13px] text-gray-700 border-y border-solid w-[15%]"
                  :class="selectedPlanId?.id == plan.id ? 'border-[#7695FF]' : 'border-[#EFEFEF]'"
>
                    {{ $helper.formattedPercentage(plan.interest_rate) || '-' }}
                  </td>

                  <td
v-if="section.extraHeaders && section.extraHeaders.includes('Loan Term')" class="p-2 text-[13px] text-gray-700 border-y border-solid w-[15%]"
                  :class="selectedPlanId?.id == plan.id ? 'border-[#7695FF]' : 'border-[#EFEFEF]'"
>
                    {{ plan.description || '-' }}
                  </td>

                  <td
v-if="section.extraHeaders && section.extraHeaders.includes('Payment Factor')" class="p-2 text-[13px] text-gray-700 border-y border-solid w-[15%]"
                  :class="selectedPlanId?.id == plan.id ? 'border-[#7695FF]' : 'border-[#EFEFEF]'"
>
                    {{ $helper.formattedPercentage(plan.payment_factor) || '-' }}
                  </td>
                  <td
class="p-2 text-[13px] min-w-[20%] text-center text-gray-700 border-y border-solid"
                  :class="selectedPlanId?.id == plan.id ? 'border-[#7695FF]' : 'border-[#EFEFEF]'"
>
${{ $helper.getFormattedAmount_(plan.min) || 0 }}
</td>
                  <td
class="p-2 text-[13px] min-w-[20%] text-center text-gray-700 border-y border-solid"
                  :class="selectedPlanId?.id == plan.id ? 'border-[#7695FF]' : 'border-[#EFEFEF]'"
>
${{ $helper.getFormattedAmount_(plan.max) || 0 }}
</td>
                  <td
class="p-2 text-[13px] w-[5%] border-solid border-t border-b border-r rounded-r-[5px]"
                  :class="selectedPlanId?.id == plan.id ? 'border-[#7695FF]' : 'border-[#EFEFEF]'"
>
                    <div
class="w-5 h-5 flex justify-center items-center rounded-full border-1 transition-all"
                      :class="selectedPlanId?.id == plan.id ? 'border-[#7695FF] bg-white' : 'border-[#CCCCCC] bg-white'"
>
                      <div v-if="selectedPlanId?.id === plan.id" class="w-2.5 h-2.5 rounded-full bg-[#7695FF]" />
                      
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- only for mobile/tablets -->
          <div
v-for="(section, sIdx) in financialPlans" :key="sIdx" class="rounded-lg  mobile:block laptop:hidden" 
          :class="sIdx > 0 ? 'mt-[15px]' : '' "
>
<div
v-if="(section.extraHeaders.length > 0) || section.category" class="bg-[#A3AAD2] text-white text-left p-2.5 text-[13px] font-bold rounded-[5px] relative font-roboto description--text"
              v-html="section.category"
/>
            <div
v-for="(plan, pIdx) in section.plans" :key="pIdx" class="w-full border-[1px] border-solid rounded-[10px] p-2.5 !pt-0 font-roboto"
              :class="[selectedPlanId?.id == plan.id ? 'border-[#7695FF]' : 'border-[#EFEFEF]',
              pIdx === 0 ? 'mt-1' : 'mt-2.5',
              ]" @click="selectedPlanId = plan"
>
              <div class="py-2 flex justify-between items-center border-b border-[#EFEFEF]">
                <span v-if="plan.plan_number" class="text-[14px] font-bold text-[#5B616B]">Plan No.:</span>
                <span v-else class="text-[14px] font-normal text-[#333333]">N/A</span>
                <span class="text-[14px] font-bold text-[#333333]">{{ plan.plan_number || '-' }}</span>
              </div>
              <div v-if="section.extraHeaders.length == 0" class="py-2 flex flex-col border-b border-[#EFEFEF]">
                <span v-if="plan.description" class="text-[14px] font-bold text-[#5B616B]">Plan:</span>
                <span v-else class="text-[14px] font-normal text-[#333333]">N/A</span>
                <span class="text-[14px] font-normal text-[#333333]" v-html="plan.description" />
              </div>
              <div
v-if="section.extraHeaders && section.extraHeaders.includes('Interest Rate')"
                class="py-2 flex justify-between items-center border-b border-[#EFEFEF]"
>
                <span class="text-[14px] font-normal text-[#5B616B]">Interest Rate</span>
                <span class="text-[14px] font-normal text-[#333333]">{{ $helper.formattedPercentage(plan.interest_rate) || '-' }}</span>
              </div>
              <div
v-if="section.extraHeaders && section.extraHeaders.includes('Loan Term')"
                class="py-2 flex justify-between items-center border-b border-[#EFEFEF]"
>
                <span class="text-[14px] font-normal text-[#5B616B]">Loan Term</span>
                <span class="max-w-[70%] text-right text-[14px] font-normal text-[#333333]">{{ plan.description || '-' }}</span>
              </div>
              <div
v-if="section.extraHeaders && section.extraHeaders.includes('Payment Factor')"
                class="py-2 flex justify-between items-center border-b border-[#EFEFEF]"
>
                <span class="text-[14px] font-normal text-[#5B616B]">Payment Factor</span>
                <span class="text-[14px] font-normal text-[#333333]">{{ $helper.formattedPercentage(plan.payment_factor) || '-' }}</span>
              </div>
              <div class="flex justify-between items-center p-2.5 mt-1.5 bg-[#F3F4F7]">
                <span class="text-[14px] font-normal text-[#5B616B]">Min Loan Amt</span>
                <p class="mb-0 text-[14px] font-bold text-[#333333]">
${{ $helper.getFormattedAmount_(plan.min) || 0 }}
</p>
              </div>
              <div class="flex justify-between items-center p-2.5 mt-1.5 bg-[#F3F4F7]">
                <span class="text-[14px] font-normal text-[#5B616B]">Max Loan Amt</span>
                <p class="mb-0 text-[14px] font-bold text-[#333333]">
${{ $helper.getFormattedAmount_(plan.max) || 0 }}
</p>
              </div>
            </div>
          </div>
        </div>
        <p class="text-[12px] laptop:text-[14px] text-[#333] m-[20px] text-center">
          Version 2.1.19 *Loan Programs, interest rates, and terms are subject to change without notice.     Please contact 
                      Service Finance Company, LLC with any additional questions and for pricing.
        </p>
      </div>

      <!-- Footer Buttons -->
      <div class="p-4 flex justify-center gap-4">
        <button
class="fxBtnSecondary mobile:hidden laptop:flex"
          @click="close"
>
          Cancel
        </button>
        <button
class="fxBtnPrimary"
          @click="submit"
>
          Continue
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapActions,
  mapGetters,
} from "vuex";

import FxModalHeader from "../nest_components/FxModalHeader.vue";
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
  name: 'FinancingModal',
  components: { FxModalHeader },
  data() {
    return {
      isVisible: false,
      selectedPlanId: null,
    }
  },

  computed: {
    ...mapGetters(["financialPlans"]),
  },

  watch: {
    financialPlans: function () {
      this.selectedPlanId = null
      document.documentElement.style.overflow = 'hidden';
      this.isVisible = true;
    },
  },

  methods: {
    ...mapActions(["getFinancialPlans"]),

    async show(id) {
      this.getFinancialPlans({
        institute_id: id
      })
    },

    close() {
      document.documentElement.style.overflow = '';
      this.isVisible = false;
    },
    submit() {
      if (this.selectedPlanId) {
        this.$emit('selected', this.selectedPlanId);
        this.close();
      } else {
        toast.error("Please select a plan.");
      }
    }
  }
}
</script>

<style scoped>
.animate-in {
  animation: animate-in 0.2s ease-out;
}

@keyframes animate-in {
  from {
    opacity: 0;
    transform: scale(0.95);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 2px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #A3AAD2;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: #7695FF;
}
</style>
<style>
  .description--text u{
      font-size: 14px;
    }
@media (max-width: 1024px) {
  .description--text u{
    font-size: 13px !important;
  }
}
</style>